// extracted by mini-css-extract-plugin
export var button = "_fd-4";
export var hasDarkBackground = "_fd-7";
export var hasLightBackground = "_fd-6";
export var iconWrapper = "_fd-0";
export var large = "_fd-2";
export var medium = "_fd-1";
export var small = "_fd-5";
export var xsmall = "_fd-3";